import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class SubscribeForm {
	static classname = 'subscribe-form';

	constructor($form) {
		this.$form = $form;

		this.bindGlobalEvents();
	}

	bindGlobalEvents() {
		$(document).ajaxSuccess(function (event, xhr, settings) {
			if (settings.url.indexOf('/mailer/subscribe/') > -1 && settings.type === 'POST') {
				let response = xhr.responseJSON;

				if (response && response.status === 'ok') {
					$(document).trigger('mailer_subscribe');
				}
			}
		});
	}

}
